const scrolled = {
  mounted(){
    this.bindEventScroll();
    window.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.onScroll);
  },
  updated(){
    this.bindEventScroll();
  },
  data(){
    return{
      isScrolled: false
    }
  },
  methods: {
    bindEventScroll(){
      const winT = window.pageYOffset;
      const setIsScrolled = winT > 0;
      this.isScrolled = setIsScrolled;
    },
    onScroll() {
      this.bindEventScroll();
    }
  }
}
export default scrolled;